import VmpRebroadCast from './src/main.vue';

VmpRebroadCast.install = function (Vue) {
  Vue.component(VmpRebroadCast.name, VmpRebroadCast);
};

export default VmpRebroadCast;
